import PropTypes from 'prop-types';

export const ErrorShape = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            message: PropTypes.string,
        }),
    ),
]);

export const ErrorsShape = PropTypes.objectOf(ErrorShape);

export const SelectOptionsShape = PropTypes.arrayOf(
    PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
);

export const ItemContentShape = PropTypes.shape({
    thumbnail_url: PropTypes.string,
    text: PropTypes.string,
});

export const UserShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    avatar_url: PropTypes.string.isRequired,
    avatar_url_medium: PropTypes.string.isRequired,
    date_joined: PropTypes.string.isRequired,
    consultant: PropTypes.shape({
        id: PropTypes.number.isRequired,
        cat: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            }),
        ),
    }),
});

export const MediaCacheShape = PropTypes.shape({
    content_preview: ItemContentShape.isRequired,
    content_type: PropTypes.oneOf(['MediaCache']).isRequired,
    id: PropTypes.number.isRequired,
    is_talent: PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired,
    media: PropTypes.number.isRequired,
    number_of_favourites: PropTypes.number.isRequired,
    number_of_public_comments: PropTypes.number.isRequired,
    number_of_visits: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    user: UserShape,
});

export const MemberShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    num_logins: PropTypes.number.isRequired,
    content_preview: ItemContentShape.isRequired,
    content_type: PropTypes.oneOf(['Member']).isRequired,
    number_of_public_comments: PropTypes.number.isRequired,
    number_of_public_uploads: PropTypes.number.isRequired,
    age: PropTypes.string.isRequired,
    user: UserShape,
});

export const MediaItemShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
});

export const FilterChoiceShape = PropTypes.shape({
    filter: PropTypes.object.isRequired, // eslint-disable-line
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    contentType: PropTypes.string,
    allowUploadNew: PropTypes.bool,
    extraQueryParams: PropTypes.objectOf(PropTypes.string),
});

export const SimpleFilterChoiceShape = PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
});

export const RequestCategoryShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    codename: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
});

export const MentorShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    is_consultant: PropTypes.bool.isRequired,
    user: UserShape,
    info: PropTypes.string.isRequired,
    cat: PropTypes.arrayOf(RequestCategoryShape),
});

export const ProjectShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    seo_title: PropTypes.string.isRequired,
    ingress: PropTypes.string.isRequired,
    project_type: PropTypes.string.isRequired,
    facade_thumbnail_large_url: PropTypes.string.isRequired,
});

export const FPImageShape = PropTypes.shape({
    order: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    flavour: PropTypes.string.isRequired,
});

export const ArticleCategoryShape = PropTypes.shape({
    codename: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
});

export const ArticleShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    ingress: PropTypes.string.isRequired,
    category: ArticleCategoryShape.isRequired,
    facade: PropTypes.shape({
        thumbnail: PropTypes.string.isRequired,
    }).isRequired,
    created_at: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
});



// WEBPACK FOOTER //
// ./src/utils/shapes.js